import { useObservable } from '@brainfocus/web/utils/react/use_observable';
import type { Preference } from '@brainfocus/web/shared/storage/preference';

/**
 * `[value, set]` of a preference for a component, re-rendering on every change
 * (#1166). Kept apart from `preference.ts` so `domain/` code can use preferences
 * without pulling in Preact.
 */
export function usePreference<T>(preference: Preference<T>): [T, (value: T) => void] {
    return [useObservable(preference.value$), preference.set];
}
